export { TouchBackend as default } from 'react-dnd-touch-backend';
